/* Gochujar: cap long Judge.me reviews at 5 lines on phones (6 on desktop) with a "Read more" / "Show less" link. Added 2026-10-02. v2: keeps the link attached to its review when Judge.me inserts extra blocks after the text.
   Works on product-page review lists, including reviews Judge.me loads later (pagination, sorting). */
(function(){
  var CSS = '.jdgm-rev__body.gj-clamp{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:6;overflow:hidden;}' +
    '@media (max-width:767px){.jdgm-rev__body.gj-clamp{-webkit-line-clamp:5;}}' +
    '.jdgm-rev__body.gj-clamp p{margin-bottom:0 !important;}' +
    '.gj-readmore{display:inline-block;margin:6px 0 0;padding:0;background:none;border:0;cursor:pointer;font:600 14px/1.4 "IBM Plex Sans KR",sans-serif;color:#0D6B41;text-decoration:underline;text-underline-offset:3px;}' +
    '.gj-readmore[hidden]{display:none;}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  var BTN = new WeakMap();
  function setup(body){
    if (body.dataset.gjRm) return;
    body.dataset.gjRm = '1';
    body.classList.add('gj-clamp');
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'gj-readmore'; btn.textContent = 'Read more'; btn.hidden = true;
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var open = !body.classList.contains('gj-clamp');
      if (open){ body.classList.add('gj-clamp'); btn.textContent = 'Read more'; }
      else { body.classList.remove('gj-clamp'); btn.textContent = 'Show less'; }
    });
    BTN.set(body, btn);
    body.insertAdjacentElement('afterend', btn);
    check(body, btn);
  }
  function check(body, btn){
    btn = btn || BTN.get(body);
    if (!btn) return;
    if (body.nextElementSibling !== btn) body.insertAdjacentElement('afterend', btn);
    if (!body.classList.contains('gj-clamp')) return;
    btn.hidden = !(body.scrollHeight > body.clientHeight + 2);
  }
  function scan(){
    var list = document.querySelectorAll('.jdgm-rev-widg .jdgm-rev__body');
    for (var i = 0; i < list.length; i++) setup(list[i]);
    recheck();
  }
  function recheck(){
    var list = document.querySelectorAll('.jdgm-rev__body[data-gj-rm]');
    for (var i = 0; i < list.length; i++) check(list[i]);
  }
  var t;
  new MutationObserver(function(){ clearTimeout(t); t = setTimeout(scan, 150); }).observe(document.documentElement, {childList:true, subtree:true});
  window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(recheck, 150); });
  window.addEventListener('load', function(){ scan(); setTimeout(recheck, 1500); });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
})();
